
import React from "react";
import { useParams } from "react-router-dom";
import { cards } from "../pages/cardsData"; 
import in1 from "../image/in1.png";
import in2 from "../image/in2.png";
import in3 from "../image/in3.png";

function ServiceDetail() {
  const { id } = useParams();
  const card = cards[id]; 

  if (!card) {
    return <h2>Service not found</h2>;
  }

  return (
    <div className="service-detail">
      <h1 >{card.title}</h1>
      <img src={card.image} alt={card.alt} />
      <p>{card.text}</p>
      <br/>
      <h1>We invite you to visit us and explore our services!</h1>
       <div className="extra-gallery"> 
        <img src={in2} alt="Our Store Front" /> 
        <p>Come see our welcoming store front.</p> 
        <img src={in1} alt="Interior View" /> 
        <p>Enjoy a comfortable and modern interior.</p> 
        <img src={in3} alt="Our Team" /> 
        <p>See our advanced machines in action.</p> 

      </div>
      <h3 alt="Near by S-24 second floor manish global mall, sector 22, dwarka delhi 110077" >Near by S-24 second floor manish global mall, sector 22, dwarka delhi 110077 </h3>
    </div>
  );
}

export default ServiceDetail;
